<template>
  <row :gutter="48" class="sc-common-info">
    <i-col span="14">
      <div class="sc-common-info__amount">
        <span class="ms-help label">{{ getSumLabel() }}</span>
        <div class="sc-common-info__amount-value">
          <input-number
            class="sc-common-info__percentage-input"
            v-if="isPercentageActive"
            size="default"
            v-model="contract[`${type}_percentage`]"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
            :min="0"
            :max="maxPercentage"
            @on-change="changePercentage"
          />
          <input-number
            class="sc-common-info__amount-input"
            size="default"
            :min="0"
            :max="maxAmount"
            :formatter="costsFormatter"
            :parser="costsParser"
            v-model="contract[`${type}_amount`]"
            :disabled="isPercentageActive"
          />
          <dropdown @on-click="calcStagesValues">
            <a class="ms-link" href="javascript:void(0)">
              Пересчитать по этапам
              <icon type="ios-arrow-down" />
            </a>
            <dropdown-menu slot="list">
              <dropdown-item name="equal"> Пропорционально </dropdown-item>
            </dropdown-menu>
          </dropdown>
        </div>
      </div>
    </i-col>
    <i-col span="10">
      <span class="ms-help label">{{ getDaysLabel() }}</span>
      <div class="sc-common-info__days" v-if="!isDateActive">
        <input-number
          size="default"
          v-model="contract[`${type}_condition`]"
          :min="0"
        />
        <double-switcher
          :contract="contract"
          :value="`${type}_condition_is_calendar`"
          left="раб."
          right="кален."
        />
      </div>
      <div class="sc-common-info__date" v-else>
        <date-picker
          size="default"
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          v-model="contract[`${type}_condition_date`]"
        />
      </div>
    </i-col>
  </row>
</template>

<script>
import DoubleSwitcher from '../double-switcher'
import { costsFormatter, costsParser, round } from '@/utils'

export default {
  props: ['contract', 'type'],
  components: {
    DoubleSwitcher
  },
  computed: {
    isPercentageActive () {
      const scenario = this.contract[`${this.type}_scenario`]

      return scenario !== 1
    },
    isDateActive () {
      const type = this.contract[`${this.type}_date_type`]

      return type === 2
    },
    maxPercentage () {
      const otherType = this.type === 'prepaid' ? 'retention' : 'prepaid'

      return 100 - this.contract[`${otherType}_percentage`]
    },
    contractCosts () {
      const sum = this.contract.roadmaps.reduce((prev, r) => prev + r.costs, 0)

      return sum
    },
    maxAmount () {
      const otherType = this.type === 'prepaid' ? 'retention' : 'prepaid'

      return this.contractCosts - this.contract[`${otherType}_amount`]
    }
  },
  methods: {
    getSumLabel () {
      return this.isPercentageActive
        ? 'Общая сумма (в процентах)'
        : 'Общая сумма (абсолютное значение)'
    },
    getDaysLabel () {
      return this.isDateActive
        ? 'Срок получения (конкретная дата)'
        : 'Срок получения (количество дней)'
    },
    setEqualValues () {
      let { roadmaps } = this.contract
      const scenario = this.contract[`${this.type}_scenario`]

      if (scenario === 3) {
        roadmaps = roadmaps.filter((r, i) =>
          this.contract[`${this.type}_stages`].includes(i)
        )
      }

      const total = this.contract[`${this.type}_amount`]

      roadmaps.forEach((r) => {
        const percentage = r.costs / this.contractCosts

        this.$set(r, `${this.type}_value`, round(total * percentage, 2))
      })
    },
    setPercentageValues () {
      const type = this.contract[`${this.type}_scenario`]
      const stages = this.contract[`${this.type}_stages`]
      const roadmaps =
        type === 2
          ? this.contract.roadmaps
          : this.contract.roadmaps.filter((_, i) => stages.includes(i))

      roadmaps.forEach((r) => {
        const { costs } = r
        const value = (costs * this.contract[`${this.type}_percentage`]) / 100
        const roundValue = round(value, 2)

        this.$set(r, `${this.type}_value`, roundValue)
      })
    },
    setData (index, name, value) {
      this.$set(this.contract.roadmaps[index], name, value)
    },
    calcStagesValues (name) {
      const type = this.contract[`${this.type}_scenario`]

      switch (name) {
        case 'equal':
          if (type === 2 || type === 3) return this.setPercentageValues()
          return this.setEqualValues()
      }
    },
    changePercentage (value) {
      const selected = this.contract[`${this.type}_stages`]
      let roadmaps = this.contract.roadmaps

      if (this.contract[`${this.type}_scenario`] === 3) {
        roadmaps = roadmaps.filter((_, i) => selected.includes(i))
      }

      const costs = roadmaps.reduce((prev, el) => prev + el.costs, 0)

      this.contract[`${this.type}_amount`] = round((costs * value) / 100, 2)
    },
    costsFormatter,
    costsParser
  }
}
</script>

<style lang="less">
.sc-common-info {
  &__percentage {
    &-input {
      margin-right: 16px;
      width: 72px;
    }
  }

  &__amount {
    &-input {
      flex: 1;
      margin-right: 16px;

      .ivu-input-number-handler-wrap {
        display: none;
      }
    }

    &-value {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__days {
    display: flex;
    align-items: center;

    .ivu-input-number {
      margin-right: 16px;
    }
  }
}
</style>
